import type { FC } from 'react';

import type { PaymentsSummary } from '@/types/payment.types';
import { formatRupeesExact } from '@/utils/currency.util';

interface PaymentsSummaryCardsProps {
  summary: PaymentsSummary | undefined;
}

const Card: FC<{ label: string; value: string; hint?: string }> = ({ label, value, hint }) => (
  <div className="rounded-xl border border-[var(--color-divider)] bg-white p-4">
    <p className="text-[11px] font-semibold uppercase tracking-wide text-[var(--color-ink-muted)]">
      {label}
    </p>
    <p className="mt-1 text-[22px] font-bold text-[var(--color-ink)]">{value}</p>
    {hint ? <p className="text-[11px] text-[var(--color-ink-muted)]">{hint}</p> : null}
  </div>
);

const PaymentsSummaryCards: FC<PaymentsSummaryCardsProps> = ({ summary }) => (
  <div className="grid grid-cols-2 gap-3 lg:grid-cols-3">
    <Card
      label="Total revenue"
      value={summary ? formatRupeesExact(summary.totalRevenuePaise) : '—'}
      hint="commission + settlement fees"
    />
    <Card
      label="Commission earned"
      value={summary ? formatRupeesExact(summary.commissionRevenuePaise) : '—'}
      hint="verified bookings"
    />
    <Card
      label="Settlement fees"
      value={summary ? formatRupeesExact(summary.settlementFeeRevenuePaise) : '—'}
      hint="on settled payouts"
    />
    <Card
      label="GST to remit"
      value={summary ? formatRupeesExact(summary.gstLiabilityPaise) : '—'}
      hint="statutory liability"
    />
    <Card
      label="Deposits held"
      value={summary ? formatRupeesExact(summary.depositsHeldPaise) : '—'}
      hint="pending refund"
    />
    <Card
      label="To settle"
      value={summary ? String(summary.pendingSettlementCount) : '—'}
      hint={summary ? `${summary.awaitingVerificationCount} awaiting verification` : undefined}
    />
  </div>
);

export default PaymentsSummaryCards;
